import { render, staticRenderFns } from "./x-menu.vue?vue&type=template&id=1aaab6ad&scoped=true&"
import script from "./x-menu.vue?vue&type=script&lang=js&"
export * from "./x-menu.vue?vue&type=script&lang=js&"
import style0 from "./x-menu.vue?vue&type=style&index=0&id=1aaab6ad&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaab6ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1aaab6ad', component.options)
    } else {
      api.reload('1aaab6ad', component.options)
    }
    module.hot.accept("./x-menu.vue?vue&type=template&id=1aaab6ad&scoped=true&", function () {
      api.rerender('1aaab6ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-menu.vue"
export default component.exports